<template>
	<div v-if="marketAccount" id="market-account-shipping-serivce-component-root">
		<b-modal
			v-model="modalWarningState"
			id="modal-warning-dialog"
			title="Vorgang Abbrechen"
			size="sm"
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-footer
		><!-- modal -->
			<p>Sind Sie sicher, dass Sie den Versanddienstleister ohne zu speichern schliessen wollen?</p>
			<div slot="modal-footer" class="w-100">
				<b-row>
					<b-button
						centered
						size="md"
						class="float-right mr-1 ml-2"
						variant="danger"
						@click="() => { this.close(); this.modalWarningState = false }"
					>wirklich schliessen</b-button>
					<b-button
						centered
						size="md"
						class="float-right mx-1"
						variant="primary"
						@click="modalWarningState = false"
					>weiter editieren</b-button>
				</b-row>
			</div>
		</b-modal>
		<b-modal
			v-model="modalInvalidDataState"
			id="modal-warning-dialog"
			title="Ungültige Daten"
			size="md"
			centered
			no-close-on-backdrop
			no-close-on-esc
			ok-title="ok"
			cancel-disabled
			cancel-title="abbrechen"
		><!-- modal -->
			<p>Versanddienstleister kann nicht abgespeichert werden. Jeder hinzugefügter Eintrag muss sowohl <b>URL</b> und <b>Carrier Code</b> haben.</p>
		</b-modal>
		<b-modal
			id="market-account-shipping-serivce-main-modal"
			v-model="visible"
			size="xl"
			no-close-on-backdrop
		>
			<div slot="modal-header" class="d-flex align-items-center w-100">
				<div class="col-8 pl-0">
					<h5 class="ml-0 pb-0 mb-0 mr-auto">
						<b>{{ this.marketAccount.name }}</b> Shipping Services bearbeiten
					</h5>
				</div>
				<div class="col-4 pr-1">
					<b-form-select
						id="edit-modal-market-account-select"
						v-model="selectedShippingServiceId"
						:options="remainingShippingServices"
						size="sm"
						class="d-flex justify-content-end mx-1"
					>
						<template #first>
							<b-form-select-option :value="null" disabled>Market Account auswählen</b-form-select-option>
						</template>
					</b-form-select>
				</div>
			</div>
			<b-table
				id="table-edit-shipping-service"
				:items="marketAccount.market_account_shipping_services"
				:fields="fields"
				:tbody-tr-class="rowClass"
				small
			><!-- table -->
				<template v-slot:cell(shippingServiceId)="row">
					<div v-if="row.item.destinationCountryId == null" class="d-flex">
						{{ getShippingServicename(row.item.shippingServiceId) }}
						<b-btn size="sm" class="ml-2" variant="primary" @click="showCountries = !showCountries; aktiveRow = row.item.id"><i class="bi bi-plus-square"></i></b-btn>
						<select class="form-control form-control-sm mt-1 ml-2" style="width: 150px;" v-if="showCountries && row.item.id === aktiveRow && row.item.destinationCountryId == null" @change="addSubMass(row.item, $event.target.value)">
							<option v-for="country in countries" :value="country.value">{{ country.text }}</option>
						</select>
					</div>
					<div v-else class="d-flex">
						<span style="margin-left: 5%;">
							{{ getCountryISo(row.item.destinationCountryId) }}
						</span>
					</div>
				</template>
				<template v-slot:cell(carrierCode)="row">
					<b-input size="sm" v-model="row.item.carrierCode"/>
				</template>
				<template v-slot:cell(carrierName)="row">
					<b-input size="sm" v-model="row.item.carrierName"/>
				</template>
				<template v-slot:cell(carrierProduct)="row">
					<b-input size="sm" v-model="row.item.carrierProduct"/>
				</template>
				<template v-slot:cell(url)="row">
					<b-input size="sm" v-model="row.item.url"/>
				</template>
				<template v-slot:cell(action)="row">
					<b-button size="sm" @click="removeMass(row.item)"><span class="icon icon-bin"/></b-button>
				</template>
			</b-table>
			<template #modal-footer>
				<div class="w-100">
					<b-button class="float-right mx-1"
						centered
						size="md"
						variant="primary"
						@click="saveMass()"
						:disabled="queryInProgress"
					>speichern</b-button>
					<b-button
						class="float-right"
						size="md"
						variant="secondary"
						@click="modalWarningState = true"
						:disabled="queryInProgress"
					>schliessen</b-button>
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
export default
{
	props: [ "marketAccount" ],
	data() {
		return {
			modalWarningState: false,
			modalInvalidDataState: false,
			queryInProgress: false,
			selectedShippingServiceId: null,
			destinationCountryId: null,
			visible: false,
			countries: [],
			showCountries: false,
			aktiveRow: null,
			fields: [
				{ key: 'shippingServiceId', label: 'Name'            , sortable: true  },
				{ key: 'carrierCode'      , label: 'Carrier Code'    , sortable: true  },
				{ key: 'carrierName'      , label: 'Carrier Name'    , sortable: true  },
				{ key: 'carrierProduct'   , label: 'Carrier Product' , sortable: true  },
				{ key: 'url'              , label: 'URL'             , sortable: true  },
				// { key: 'marketAccountId'  , label: 'Market Account'  , sortable: true  },
				{ key: 'action'           , label: ''                , sortable: false },
			],
		}
	},
	watch: {
		marketAccount: function(newMarketAccount) {
			if( null !== newMarketAccount) {
				this.visible = true;
			}
			this.sortMass()
		},
		selectedShippingServiceId: function(n) {
			if(null !== n) {
				this.addMass();
			}
		}
	},
	computed: {
		remainingShippingServices: function() {
			return this.shippingServices.filter( shippingService => {
				const maybe = this.marketAccount.market_account_shipping_services.find( mass => {
					return mass.shippingServiceId == shippingService.id
				});
				if(maybe) return false;
				return true;
			}).map( shippingService => {
				return { text: shippingService.name, value: shippingService.id };
			});
		}
	},
	methods: {
		addMass() {
			this.marketAccount.market_account_shipping_services.push({
				id: null,
				carrierCode: null,
				marketAccountId:   this.marketAccount.id,
				shippingServiceId: this.selectedShippingServiceId,
			});
		},
		addSubMass(baseMass, destinationCountryId) {
			if(!this.showCountries) return;
			this.marketAccount.market_account_shipping_services.push({
				id: null,
				carrierCode: null,
				marketAccountId:   this.marketAccount.id,
				shippingServiceId: baseMass.shippingServiceId,
				destinationCountryId: Number(destinationCountryId),

			});
			console.log(this.marketAccount.market_account_shipping_services[this.marketAccount.market_account_shipping_services.length - 1]);
			this.sortMass()
		},
		removeMass(mass) {
			if(!mass.id) {
				this.marketAccount.market_account_shipping_services =
										this.marketAccount.market_account_shipping_services
										.filter( other => other.id !== mass.id );
				return;
			}
			this.queryInProgress = true;
			Promise.all([
				axios.delete( `/shipping_service/delete/${mass.id}`)
				, new Promise( r => setTimeout(r, 333))
			]).then( () => {
				this.marketAccount.market_account_shipping_services =
										this.marketAccount.market_account_shipping_services
										.filter( other => other.id !== mass.id );
				this.queryInProgress = false;

				this.$bvToast.toast(
					"Aktion erfolgreich ausgeführt.",
					{ title: "Shipping Service", noAutoHide: false,
					autoHideDelay: 1250, appendToast: false, variant: 'success'
				});
			}).catch( error => {
				alert("Shipping Service konnte nicht gelöscht werden. Bitte den Devs melden.");
				console.error(error);
				this.queryInProgress = false;
			});
		},
		//to sort the Mass, so that they are "grouped" together
		sortMass(){
			if (!this.marketAccount || !this.marketAccount.market_account_shipping_services) {
				return;
			}
			this.marketAccount.market_account_shipping_services = this.marketAccount.market_account_shipping_services.sort((a, b) => {
				if (a.shippingServiceId !== b.shippingServiceId) {
					return a.shippingServiceId - b.shippingServiceId;
				}
				if (a.destinationCountryId === null && b.destinationCountryId !== null) {
					return -1;
				}
				if (a.destinationCountryId !== null && b.destinationCountryId === null) {
					return 1;
				}
				return 0;
			});
		},
		saveMass() {
			for(const mass of this.marketAccount.market_account_shipping_services)
			{
				if((!mass.carrierCode) || (mass.carrierCode == "")){
					this.modalInvalidDataState = true;
					return;
				}
			}
			this.queryInProgress = true;
			Promise.all([
				axios.post( "/shipping_service/save_shipping_service_market_accounts", {
					payload: JSON.stringify(this.marketAccount.market_account_shipping_services),
				})
				, new Promise( r => setTimeout(r, 333))
			]).then( ([response]) => {
				this.queryInProgress = false;
				this.destinationCountryId = null;
				this.showCountries = false;
				this.aktiveRow = null;
				this.sortMass();
				this.marketAccount.market_account_shipping_services = _.cloneDeep(response.data);
				this.$bvToast.toast(
					"Aktion erfolgreich ausgefuehrt.",
					{ title: "Shipping Service", noAutoHide: false,
					autoHideDelay: 1250, appendToast: false, variant: 'success'
				});
			}).catch( error => {
				this.queryInProgress = false;
				console.error(error);
				this.$bvToast.toast(
					"Versanddienstleister nicht abgespeichert.",
					{ title: "Fehler", noAutoHide: false,
					autoHideDelay: 92500, appendToast: false, variant: 'danger'
				});
			});
		},
		rowClass(shippingService, type) {
			if (!shippingService || type !== 'row') return;
			if((!shippingService.carrierCode) || (shippingService.carrierCode == "")) {
				return 'table-warning';
			}
			if (!shippingService.id) return 'table-success';
		},
		close() {
			this.visible = false;
			this.queryInProgress = false;
			this.selectedShippingServiceId = null;
			this.$emit("closed"); // parent will reset marketAccount for this comp.
		},
		getShippingServicename(id){
			return this.shippingServices.find(x => x.id == id)?.name;
		},
		getCountryISo(id){
			if(!id) return "";
			return this.countries.find(x => x.value == id)?.text.substring(0, 2);
		}
	},
	created() {
		Promise.all([
			axios.get("/shipping_service/all_only_shipping_services"),
			axios.get("/country/all")
		]).then( ([ShippingServiceResponse, countryResponse]) => {
			this.shippingServices = ShippingServiceResponse.data;
			this.countries = countryResponse.data.map( country => {
				return { text: country.countryIso + " - " + country.countryName, value: country.id };
			}).sort(
				(a, b) => a.text.localeCompare(b.text)
			);
		});
	},
}
</script>
